import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useSnackbar } from 'notistack';
import formatAppConfiguration from '../../utils/formatAppConfiguration';
import IntegrationForm from '../IntegrationForm';
import FormDrawer from '@afosto/app-components-react/FormDrawer';
import { integrations as integrationsApi } from '@afosto/apps/api/Integrations';
import translations from './translations';

const EditIntegrationDrawer = ({ app, integration, isOpen, onClose, onSave }) => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();

  const handleSaveIntegration = async ({ name, configuration, credentials }) => {
    try {
      const response = await integrationsApi.updateIntegration(integration?.id, {
        name,
        configuration: formatAppConfiguration(configuration, integration.app_code),
        credentials,
      });

      enqueueSnackbar(intl.formatMessage(translations.feedback.integrationUpdated), {
        variant: 'success',
      });

      if (onSave && typeof onSave === 'function') {
        onSave(response?.data);
      }
    } catch (err) {
      enqueueSnackbar(intl.formatMessage(translations.feedback.integrationNotUpdated), {
        variant: 'error',
      });
    }
  };

  return (
    <FormDrawer
      drawerWidth="420px"
      isOpen={isOpen}
      onClose={onClose}
      title={intl.formatMessage(translations.title)}
    >
      <IntegrationForm
        app={app}
        integration={integration}
        onCancel={onClose}
        onSubmit={handleSaveIntegration}
      />
    </FormDrawer>
  );
};

EditIntegrationDrawer.propTypes = {
  app: PropTypes.object,
  integration: PropTypes.object,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
};

EditIntegrationDrawer.defaultProps = {
  app: undefined,
  integration: undefined,
  isOpen: false,
  onClose: undefined,
  onSave: undefined,
};

export default EditIntegrationDrawer;
